import { BASE_URL } from "@/constants/endpoints";
import { PurchaseOrderIntentListResponse } from "@/pages/supplies-requests/purchase-order-intent/schema/purchase-order-intent.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let POIApiPromise: Promise<AxiosInstance> | null = null;

const BASE_PATH = "/IntencionCompra";

const getPOIApi = async (): Promise<AxiosInstance | null> => {
  if (POIApiPromise) return POIApiPromise;
  POIApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return POIApiPromise;
};

export interface GetPOIListProps {
  Cuenta?: number;
  FechaSolicitud?: string;
  ZonaComercial?: string;
  TipoInsumo?: number;
  Estados?: number[];
  "P.Pagina"?: number;
  "P.Records"?: number;
};

export const getPurchaseOrderIntentList = async (
  props: GetPOIListProps,
): Promise<PurchaseOrderIntentListResponse | null> => {
  const api = await getPOIApi();
  if (!api) return null;

  const response = await api.get(`${BASE_PATH}?${objectToQueryStringWithArray(props)}`);
  return response.data;
};

export const getPurchaseOrderIntent = async (id: number): Promise<any> => {
  const api = await getPOIApi();
  if (!api) return;

  const response = await api.get(`${BASE_PATH}/${id}`);
  return response.data;
};

export interface UpdatePOIProps {
  id: number;
  estado: number;
  detalle: string;
};

export const updatePurchaseOrderIntent = async (props: UpdatePOIProps): Promise<any> => {
  const api = await getPOIApi();
  if (!api) return;

  const response = await api.put(`${BASE_PATH}/${props.id}`, props);
  return response.data;
};